<template>
  <div>
    <label class="formulate-input-label" style="margin:0;" for="valueGroup">{{label}}</label>
    <div id="valueGroup" style="display: flex; justify-content: space-between; gap: .5rem;">
      <NxInput
      name="numberInicial"
      type="number"
      placeholder="De:"
      :value="localInitialValue"
      @update:value="handleInitialValueUpdate"
    ></NxInput>
      <NxInput
      name="numberFinal"
      type="number"
      placeholder="De:"
      :value="localFinalValue"
      @update:value="handleFinalValueUpdate"
    ></NxInput>
    </div>
  </div>
</template>
<script>
import { useReactiveModelMixin } from '../../mixins'

export default {
  name: 'NxInputNumberRange',
  mixins: [useReactiveModelMixin('InitialValue'), useReactiveModelMixin('FinalValue')],
  props: {
    label: {
      required: true,
      type: String,
      default: null
    }
  },
  methods: {
    handleInitialValueUpdate (val) {
      this.localInitialValue = val
    },
    handleFinalValueUpdate (val) {
      this.localFinalValue = val
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/nexum/components/custom-inputs/NxInputNumberRange.vue